// date-fns 4.x dropped default exports from subpath modules;
// must import the named `format` from the subpath.
import { format } from 'date-fns/format';

/**
 * 1:1 with legacy `flows/bio/wall/functions/util.ts:formatPostDate`:
 *   - <1m   → "Just now"
 *   - <1h   → "N minutes ago"
 *   - <1d   → "N hours ago"
 *   - same year → "Jan 12, 3:24 PM"
 *   - else  → "Jan 12, 2024 3:24 PM"
 *   - future → absolute (scheduled posts)
 */
export function formatPostDate(date: Date): string {
  const now = new Date();
  const diff = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diff < 0) {
    return date.getFullYear() === now.getFullYear()
      ? format(date, 'MMM dd, p')
      : format(date, 'MMM dd, yyyy p');
  }
  if (diff < 60) return 'Just now';
  if (diff < 3600) return `${Math.floor(diff / 60)} minutes ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} hours ago`;
  return date.getFullYear() === now.getFullYear()
    ? format(date, 'MMM dd, p')
    : format(date, 'MMM dd, yyyy p');
}

/** Compact comment / like count formatter — `1234 → "1.2K"`. */
export function formatCount(count: number | undefined): string {
  if (!count) return '0';
  if (count >= 1000000) return `${(count / 1000000).toFixed(1)}M`;
  if (count >= 1000) return `${(count / 1000).toFixed(1)}K`;
  return String(count);
}
